import { axios } from '@Root/API'

export const remove = studyProgrammeId => {
	return axios.delete(`delete/student-course-session/${studyProgrammeId}`)
}
